module.exports = __webpack_public_path__ + "img/express-splitter-west.46ef8a5a.png";